import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import CustomModel from "@/views/CustomModel.vue";
import LightsShadows from "@/views/LightsShadows.vue";
import CameraMechanics from "@/views/CameraMechanics.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/custom-model",
    name: "CustomModel",
    component: CustomModel,
  },
  {
    path: "/lights-shadows",
    name: "LightsShadows",
    component: LightsShadows,
  },
  {
    path: "/camera-mechanics",
    name: "CameraMechanics",
    component: CameraMechanics,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
